/* eslint-disable unicorn/prefer-reflect-apply -- lib */
/* eslint-disable prefer-spread -- lib */
/* eslint-disable prefer-rest-params -- lib */

import { is, isMap } from 'immutable';
import {
  createSelectorCreator,
  defaultEqualityCheck,
  defaultMemoize,
} from 'reselect';

/**
 * Do not store any result and proceed with normal flow
 *
 * Use arguments for better performance and smooth flow control
 */
export function serverMemoize(func) {
  function ssrNoCache() {
    return func.apply(null, arguments);
  }

  return ssrNoCache;
}

/* istanbul ignore next -- reselect */
const memoizeFunc = global.BROWSER ? defaultMemoize : serverMemoize;

/**
 * Centralize equality check and enable fine tuning by types
 *
 * Use arguments for better performance and smooth flow control
 */
export function allPurposeEqualityCheck() {
  if (isMap.apply(null, arguments)) {
    return is.apply(null, arguments);
  }

  // e.g. replace with _.isEqual
  return defaultEqualityCheck.apply(null, arguments);
}

/**
 * The following setup is used by defaultMemoize
 */
const memoizeOptions = {
  // to retrieve from cache
  equalityCheck: allPurposeEqualityCheck,
  // to update value in cache under the same key
  resultEqualityCheck: allPurposeEqualityCheck,
  // for LRU cache when > 1
  maxSize: 1,
};

/**
 * The memoizeOptions can be overridden in each individual selector
 * See reselect^4.1 docs for more
 */
export const createSelector = createSelectorCreator(
  memoizeFunc,
  memoizeOptions
);

/* eslint-enable prefer-rest-params -- lib */
/* eslint-enable prefer-spread -- lib */
/* eslint-enable unicorn/prefer-reflect-apply -- lib */
